import { request } from "@/utils/remoteRequest";

export function getTree(data) {
  return request({
    url: "/depts/tree",
    method: "post",
    data,
  });
}

export function getDeptList(data) {
  return request({
    url: "/depts/searchAllDepts",
    method: "post",
    data,
  });
}

export function getList(data) {
  return request({
    url: "/depts/list",
    method: "post",
    data,
  });
}

export function saveDept(data) {
  return request({
    url: "/depts/saveDept",
    method: "post",
    data,
  });
}

export function findDeptsByParentCode(data) {
  return request({
    url: "/depts/findDepartmentByParentCode",
    method: "post",
    data,
  });
}

export function deleteDept(data) {
  return request({
    url: "/depts/delete",
    method: "post",
    data,
  });
}

export function getCurOrgList(data) {
  return request({
    url: "/depts/searchCurOrgList",
    method: "post",
    data,
  });
}
